<template>
  <section id="#cloud" class="white">
    <v-container class="py-15">
      <v-row align="center" justify="center" class="py-5">
        <v-col cols="11" md="5" class="ma-auto">
          <h1
            class="
              secondary--text
              text-h3 text-center text-xl-h2
              font-weight-thin
            "
          >
            {{ $t("tecnologia.titulo") }}
          </h1>
          <div v-scrollanimation class="hr verdeClaro my-5 mx-auto"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row class="d-flex justify-center">
            <v-col
              v-scrollanimation
              cols="10"
              md="5"
              xl="5"
              class="anim cloud d-flex align-center"
            >
              <v-img
                class="d-flex align-center"
                contain
                src="@/assets/vect/memory-storage-animate.svg"
              >
              </v-img>
            </v-col>
            <v-col cols="11" md="5" xl="5" class="d-flex align-center">
              <v-row align="end" justify="center">
                <v-col v-scrollanimation cols="12" class="anim d-flex mt-15">
                  <p class="ml-md-5 font-weight-light">
                    <strong
                      ><h2 class="mb-5">
                        {{ $t("tecnologia.cloud") }}
                      </h2></strong
                    >{{ $t("tecnologia.cloudtext") }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row  align="center" justify="center" class="my-15">
        <v-col cols="11">
          <v-row  align="start" justify="center" class="my-10">
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img contain>
                <svg
                  id="Rapidas"
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <rect
                    id="Area"
                    width="34"
                    height="34"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g id="Icon" transform="translate(4.25 2.833)">
                    <path
                      id="Path"
                      d="M19.167,3.333,5,20.333H17.75L16.333,31.667l14.167-17H17.75Z"
                      transform="translate(-5 -3.333)"
                      fill="none"
                      stroke="#27debf"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.67"
                    />
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("tecnologia.rapida") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("tecnologia.rapidatext") }}
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="34"
                  viewBox="0 0 26 34"
                >
                  <g id="API" transform="translate(-481 -1040)">
                    <g id="Icon" transform="translate(481 1040)">
                      <rect
                        id="Area"
                        width="26"
                        height="26"
                        fill="#fcfcfc"
                        opacity="0"
                      />
                      <g
                        id="Icon-2"
                        data-name="Icon"
                        transform="translate(0.951 4.281)"
                      >
                        <path
                          id="Path"
                          d="M19.611,12.089H18.262a8.563,8.563,0,1,0-8.285,10.7h9.633a5.352,5.352,0,1,0,0-10.7Z"
                          transform="translate(-1.408 -5.665)"
                          fill="none"
                          stroke="#27debf"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.67"
                        />
                      </g>
                    </g>
                    <g
                      id="Icon-3"
                      data-name="Icon"
                      transform="translate(499.889 1074) rotate(180)"
                    >
                      <rect
                        id="Area-2"
                        data-name="Area"
                        width="14"
                        height="14"
                        transform="translate(-0.111)"
                        fill="#fcfcfc"
                        opacity="0"
                      />
                      <g
                        id="Icon-4"
                        data-name="Icon"
                        transform="translate(1.872 1.931)"
                      >
                        <circle
                          id="Path-2"
                          data-name="Path"
                          cx="1.667"
                          cy="1.667"
                          r="1.667"
                          transform="translate(6.668 6.668)"
                          fill="none"
                          stroke="#27debf"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.67"
                        />
                        <circle
                          id="Path-3"
                          data-name="Path"
                          cx="1.667"
                          cy="1.667"
                          r="1.667"
                          transform="translate(0 0)"
                          fill="none"
                          stroke="#27debf"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.67"
                        />
                        <path
                          id="Path-4"
                          data-name="Path"
                          d="M0,6.668V0A5,5,0,0,0,5,5"
                          transform="translate(1.667 3.334)"
                          fill="none"
                          stroke="#27debf"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.67"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("tecnologia.integracion") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("tecnologia.integraciontext") }}
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row align="start" justify="center" class="my-10">
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img contain>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <g id="Proteccion" transform="translate(0 -0.382)">
                    <rect
                      id="Area"
                      width="34"
                      height="34"
                      transform="translate(0 0.382)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g id="Icon" transform="translate(5.72 2.918)">
                      <path
                        id="Path"
                        d="M14.775,30.269s11.442-5.72,11.442-14.3V5.958L14.775,1.667,3.333,5.958V15.968C3.333,24.549,14.775,30.269,14.775,30.269Z"
                        transform="translate(-3.333 -1.667)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("tecnologia.proteccion") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("tecnologia.protecciontext") }}
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <g id="seguridad" transform="translate(0 -0.278)">
                    <rect
                      id="Area"
                      width="34"
                      height="34"
                      transform="translate(0 0.278)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g id="Icon" transform="translate(4.28 2.895)">
                      <rect
                        id="Rect"
                        width="25.677"
                        height="15.692"
                        rx="2"
                        transform="translate(0 12.838)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <path
                        id="Path"
                        d="M5.833,14.506V8.8A7.133,7.133,0,0,1,20.1,8.8v5.707"
                        transform="translate(-0.128 -1.667)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("tecnologia.seguridad") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("tecnologia.seguridadtext") }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row v-scrollanimation justify="center" class="pt-15">
        <v-col cols="11">
          <v-row justify="center">
            <p class="info--text">{{ $t("colaboraciones") }}</p>
          </v-row>
          <v-row
            align="end"
            justify="center"
            class="d-flex column-reverse my-10"
          >
            <v-col
              cols="12"
              md="4"
              class="d-flex justtfy-space-between align-center"
            >
              <v-img
                class="mx-3 md-mx-7"
                height="70"
                width="30"
                contain
                src="../../../assets/img/alianzas/afeedme.png"
              >
              </v-img>
              <v-img
                class="mx-3 md-mx-7"
                height="40"
                width="15"
                contain
                src="../../../assets/img/alianzas/VPsuis.png"
              >
              </v-img>
              <v-img
                class="mx-3 md-mx-7"
                height="30"
                width="15"
                contain
                src="../../../assets/img/alianzas/onclick.png"
              >
              </v-img>
              <v-img
                class="mx-3 md-mx-73"
                height="30"
                width="15"
                contain
                src="../../../assets/img/alianzas/regavet.png"
              >
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Tecnologia",
};
</script>

<style scoped>

#cloud {
  background-color: white;
  min-height: 100vh;
}


/* 
    Si el elemento se cruza con la ventana gráfica, se agrega la clase antes de ingresar.
  */


.before-enter g {
  stroke-dasharray: 915;
  stroke-dashoffset: 915;
}

.enter g {
  stroke-dasharray: 915;
  stroke-dashoffset: 0;
  transition: all 3s ease-in-out;
}
</style>
